<div class="new-question-para-desc new-question-para-desc--fixed">
  <div class="new-question-para-desc__inner" [class.opened]="openEditor">
    <div class="new-question__container">
      <p [froalaView]="element.content"></p>
    </div>
  </div>
  <a (click)="openEditor=!openEditor" href="javascript:void(0)" class="bottom-tab-arrow" [class.opened]="openEditor"></a>
</div>
